// extracted by mini-css-extract-plugin
export default {"actions":"ConfirmModal__actions-Nk_A"};